@if (details().error) {
    <div class="text-large leading-relaxed mb-3">
        There was an error. Dismiss this and I will take another look at the request.
    </div>
} @else {
    <div class="text-large leading-relaxed mb-3">
        <div class="mt-2">Updates for <span class="text-bold">{{ details().name }}</span>:</div>
        @if (details().edited_attributes.length) {
            <div class="mt-2">
                <span class="text-bold">Updating:</span>
                <ul class="mt-1 mb-0">
                    @for (attribute of details().edited_attributes; track attribute[0]) {
                        <li>
                            <span class="text-bold">{{ humanizeAttribute(attribute[0]) }}:</span>
                            {{ attribute[1] }}
                        </li>
                    }
                </ul>
            </div>
        }
        @if (details().pages.length) {
            <div class="mt-2">
                <span class="text-bold">Pages after update:</span>
                <ul class="mt-1 mb-0">
                    @for (page of details().pages; track $index; let pageNumber = $index) {
                        <li>
                            <span class="text-bold">Page {{ pageNumber + 1 }}</span>
                            <ul class="mt-0 mb-0">
                                @for (moduleLabel of page; track $index) {
                                    <li>{{ moduleLabel }}</li>
                                }
                            </ul>
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
}
